import { Text } from '@arwes/core';
import React, { ReactElement } from 'react';

export function PiscesTextComponent({ children }: { children: any }): ReactElement {
  return <Text style={{ fontSize: '2rem', color: '#dcf9ff', fontWeight: 'bold' }}>{children}</Text>;
}
